import { usePublicAppStore } from "@/store";
import { observer } from "mobx-react-lite";
import { FC } from "react";
import { Outlet } from "react-router";
import { useSearchParams, useHref, useNavigate } from "react-router-dom";
import { RouterProvider } from "react-aria-components";
import { useRedirectToLandingPage } from "@/app/router/useRedirectToLandingPage";
import { useEffectOnMount } from "@/domains/react/useEffectOnMount";
import { localStorageModule } from "@/modules/local-storage";
import { useHotkey } from "@tanstack/react-hotkeys";

interface RootOutletProps {}

export const RootOutlet: FC<RootOutletProps> = observer(() => {
  useRedirectToLandingPage();

  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const { publicStore } = usePublicAppStore();
  publicStore.useInitializePublicStoreEffects({ searchParams, setSearchParams });
  const hotkeyTarget = typeof window === "undefined" ? null : window;

  useHotkey(
    { key: "|", ctrl: true, meta: true, shift: true },
    () => publicStore.debug.toggleDebugMode(),
    { target: hotkeyTarget, preventDefault: true }
  );

  useEffectOnMount(() => {
    const iosCalendarSetupDone = searchParams.get("ios-calendar-setup");
    if (iosCalendarSetupDone) {
      localStorageModule.writeIosCalendarSetup(true);
    }
  });

  return (
    <RouterProvider navigate={navigate} useHref={useHref}>
      <Outlet />
    </RouterProvider>
  );
});
